import { render } from "./ProjectsLogo.vue?vue&type=template&id=58946cc2&scoped=true"
import script from "./ProjectsLogo.vue?vue&type=script&lang=js"
export * from "./ProjectsLogo.vue?vue&type=script&lang=js"

import "./ProjectsLogo.vue?vue&type=style&index=0&id=58946cc2&scoped=true&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58946cc2"]])

export default __exports__